import { INTERNAL_SHOWPASS_API_URL, API_URL, APP_ENV } from "@shared/env";
import { getPlatform } from "@shared/utils/get-platform";

/*
  On beta and production deployments, dynamically set the baseURL for axios
  depending on whether this Repo is being initialized in a server environment
  or a client environment.
  This allows us to bypass DNS calls as our deployment are on a private network
*/

export function getBaseUrl(): string {
  // Mobile: React Native exposes `window` but requests must target API_URL, not a relative path.
  if (getPlatform() === "MOBILE") {
    return API_URL;
  }

  // Client: relative API URLs (same host as the document — custom domains, canonical host).
  if (typeof window !== "undefined") {
    // Preview deployments don't share an origin with the backend
    if (APP_ENV === "preview") {
      return API_URL;
    }
    return "";
  }

  // Server-side rendering — use internal URL to bypass DNS in deployed envs
  if (APP_ENV === "beta" || APP_ENV === "production" || APP_ENV === "demo") {
    return INTERNAL_SHOWPASS_API_URL;
  }

  return API_URL;
}
